import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=414a96c0&"
import script from "./Upgrade.vue?vue&type=script&lang=ts&"
export * from "./Upgrade.vue?vue&type=script&lang=ts&"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=414a96c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports